import { AnimateOnScroll } from "./AnimateOnScroll";

const equipmentData = [
  {
    id: "01",
    title: "Kinitas\nSlimLine",
    description:
      "SlimLine is a lightweight, freestanding self-service kiosk designed for retail stores, clinics, and fast-food environments. Its small footprint and modern design make it ideal for areas where space matters.",
    image: "/images/sec-3-homepage/s3-1.webp",
  },
  {
    id: "02",
    title: "Kinitas\nEdgeOutdoor",
    description:
      "EdgeOutdoor is a rugged, fully-sealed kiosk engineered for 24/7 outdoor operation. Perfect for parking, gas stations, and open-air environments, it's resistant to dust, rain, and temperature extremes.",
    image: "/images/sec-3-homepage/s3-s2.webp",
  },
  {
    id: "03",
    title: "Kinitas\nWallTouch",
    description:
      "WallTouch brings powerful self-service capabilities in a sleek, space-saving form. Ideal for clinics, offices, and transit hubs where wall-mounted solutions are preferred without compromising on function.",
    image: "/images/sec-3-homepage/s3-s3.webp",
  },
  {
    id: "04",
    title: "Kinitas\nCashFlex",
    description:
      "CashFlex is a cash-in/cash-out kiosk designed for bill payment, retail cash handling, and secure deposits. Built with high-volume use in mind, it supports automated reconciliation and anti-tamper security.",
    image: "/images/sec-3-homepage/s3-4.webp",
  },
];

export const Equipment = () => {
  return (
    <section id="equipment" className="py-20 px-6 lg:px-8 bg-white">
      <div className="max-w-screen-xl mx-auto">
        <AnimateOnScroll>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-[#111827] mb-14 leading-tight">
            Built to Perform. Configured <br className="hidden sm:block" /> to
            Fit. Ready to Deploy.
          </h2>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {equipmentData.map((item, index) => (
            <AnimateOnScroll
              key={item.id}
              delay={index * 0.1}
              direction={index % 2 === 0 ? "right" : "left"}
            >
              <div
                key={item.id}
                className="relative bg-[#041432] text-white rounded-2xl overflow-hidden
             w-full max-w-[630px] mx-auto
             h-[420px] sm:h-[479px] flex"
              >
                {/* Content - izquierda */}
                <div className="relative z-10 flex flex-col p-5 sm:p-8 w-[55%] sm:w-[50%]">
                  <p className="text-[32px] sm:text-[64px] font-bold opacity-40 leading-none">
                    {item.id}
                  </p>
                  <h3 className="text-lg sm:text-3xl font-bold leading-snug mt-2 whitespace-pre-line">
                    {item.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-white/80 leading-relaxed mt-6 sm:mt-10">
                    {item.description}
                  </p>
                </div>

                {/* Image - derecha */}
                <div className="w-[45%] sm:w-[50%] h-full flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};
